import { Card } from "@/types/v2";
import {
  Card as BaseCard,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/Base/Card";
import { NotesMain } from "@/components/Dashboard/components/Card/Notes.Main";
import { RO_SECTION_TITLE_CLASS } from "@/components/Common/RoDetailsPanel/roPanelStyles";
import { cn } from "@/lib/utils";

export interface RoNotesCardProps {
  cardData: Card;
  shopId: string;
}

export const RoNotesCard = ({ cardData, shopId }: RoNotesCardProps) => (
  <BaseCard className="bg-white print:break-inside-avoid print:border-gray-300 print:bg-white print:p-2">
    <CardHeader>
      <CardTitle className={cn(RO_SECTION_TITLE_CLASS, "print:text-lg")}>
        Notes
      </CardTitle>
    </CardHeader>
    <CardContent>
      <NotesMain cardData={cardData} shopId={shopId} autoFocusNewNote={false} />
    </CardContent>
  </BaseCard>
);
